import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/pcGrntCtCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getgrdList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		let stdYy = searchParams.searchDate;
		if (searchParams.searchDate !== undefined) {
			queryStr = objectToQuerystring({
				idxScn: searchParams.idxScn, //지수구분
				carScn: searchParams.carScn, //차량구분
				pacScn: searchParams.pacScn, //승상구분
				plntCd: searchParams.plntCd, //생산공장
				flclSpc: searchParams.flclSpc, //연료전지사양
				saleNat: searchParams.saleNat, //판매국가
				saleRegn: searchParams.saleRegn, //판매지역
				currentPage,
				pageUnit
			});
		}

		//console.log('queryStr	::', queryStr);
		return client
			.get(`${BASE_URL}/mqy/clma/pcGrntCnt/v1/pcGrntCnts/stdYy/${stdYy}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
